import { useState, useEffect } from "react";
import api from "../../services/api";

// null  = "no preview" (resolved, no data)
// object = preview data (resolved)
// absent from Map = not yet fetched
const previewCache = new Map();
const inFlightUrls = new Set();

const URL_RE = /https?:\/\/[^\s"'<>]+/i;

export function extractFirstUrl(text) {
  if (!text) return null;
  const match = text.match(URL_RE);
  return match ? match[0] : null;
}

const useLinkPreview = (text) => {
  const url = extractFirstUrl(text);

  const [preview, setPreview] = useState(() => {
    if (!url) return null;
    return previewCache.has(url) ? previewCache.get(url) : null;
  });

  useEffect(() => {
    if (!url) { setPreview(null); return; }

    // Already resolved
    if (previewCache.has(url)) {
      setPreview(previewCache.get(url));
      return;
    }

    // Another instance already fetching this URL — subscribe via state update when done
    if (inFlightUrls.has(url)) return;

    inFlightUrls.add(url);

    api.get("/link-preview", { params: { url } })
      .then(({ data, status }) => {
        const result = (status === 204 || !data) ? null : data;
        previewCache.set(url, result);
        setPreview(result);
      })
      .catch(() => {
        // Do not cache errors — allow retry on next page load
        inFlightUrls.delete(url);
      })
      .finally(() => {
        inFlightUrls.delete(url);
      });
  }, [url]);

  return preview;
};

export default useLinkPreview;
